import React from 'react';
import PropTypes from 'prop-types';
import getGlyph, { iconsList } from './glyphs';

function Icon({
  glyph = null,
  size = '24',
  stroke = 'currentColor',
  strokeWidth = '2',
  ...otherProps
}) {
  const Glyph = getGlyph(glyph);

  if (Glyph) {
    return <Glyph {...otherProps} size={size} stroke={stroke} strokeWidth={strokeWidth} />;
  }

  return null;
}

Icon.propTypes = {
  glyph: PropTypes.oneOf(iconsList),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  stroke: PropTypes.string,
  strokeWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default Icon;
